import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { allocationWarningConfig, planzone } from "@planzone/dto";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createSelector } from "./selector";
import { State, Selector } from "./types";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  planzone,
  allocationWarningConfig,
};

function handleRequest(state: State): State {
  return { ...state, request: setRequestStateToPending() };
}

function handleSuccess({
  planzone,
  allocationWarningConfig,
}: Boundaries["editAllocationWarning"]["success"]): State {
  return {
    request: setRequestStateToSuccess(),
    planzone,
    allocationWarningConfig,
  };
}

function handleFailure({
  planzone,
  allocationWarningConfig,
}: Boundaries["editAllocationWarning"]["failure"]): State {
  return {
    request: setRequestStateToFailure(),
    planzone,
    allocationWarningConfig,
  };
}

const reduceState = createStateReducer(initialState, {
  [events.editAllocationWarningRequested]: handleRequest,
  [events.editAllocationWarningSucceeded]: handleSuccess,
  [events.editAllocationWarningFailed]: handleFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
